const isValidTime = (time) => {
    const [hh, mm] = time.split(':');
    return (!!hh &&
        hh.length === 2 &&
        !Number.isNaN(+hh) &&
        !!mm &&
        mm.length === 2 &&
        !Number.isNaN(+mm));
};
const formatOnlyTime = (time) => isValidTime(time)
    ? new Date(`1970-01-01T${time}`).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    })
    : 'N/A';
export default formatOnlyTime;
//# sourceMappingURL=formatOnlyTime.js.map